import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column",
  id: "patient-profile-details"
}
const _hoisted_2 = { class: "task-filters" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", { value: "All" }, "All", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: "PendingAdmissionActivity" }, "Pending Admission Activity", -1 /* HOISTED */)
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "All" }, "All Admission Periods", -1 /* HOISTED */)
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: null }, "All Disciplines", -1 /* HOISTED */)
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: null }, "All Disciplines", -1 /* HOISTED */)
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: null }, "All Task Statuses", -1 /* HOISTED */)
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "task-list" }
const _hoisted_15 = { class: "bg-white rounded mt-2 h-100" }
const _hoisted_16 = { class: "h-100 d-flex flex-column mb-3 mt-2" }
const _hoisted_17 = { class: "table table-responsive-md border border-gray" }
const _hoisted_18 = { class: "bg-table-header table-header" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Task")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Status")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Schedule Start")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Schedule End")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Assigned To")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", null, "Comments", -1 /* HOISTED */)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("th", null, "Actions", -1 /* HOISTED */)
const _hoisted_26 = {
  key: 0,
  class: "table-empty"
}
const _hoisted_27 = ["colspan"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h3", null, "No Tasks Found.", -1 /* HOISTED */)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 1,
  class: "table-error"
}
const _hoisted_31 = ["colspan"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_33 = [
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HosPalProfileDetails = _resolveComponent("HosPalProfileDetails")!
  const _component_SortableTh = _resolveComponent("SortableTh")!
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_HosPalTaskRow = _resolveComponent("HosPalTaskRow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HosPalProfileDetails, {
      selectedPatientDetails: _ctx.selectedPatientDetails,
      application: _ctx.application,
      agencyId: _ctx.agencyId
    }, null, 8 /* PROPS */, ["selectedPatientDetails", "application", "agencyId"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.application === _ctx.ApplicationEnum.AxxessHospiceFE)
        ? _withDirectives((_openBlock(), _createElementBlock("select", {
            key: 0,
            class: "form-select w-35 me-2",
            name: "benefit-periods",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedBenefitPeriod) = $event))
          }, [
            _hoisted_3,
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefitPeriods, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                value: item,
                key: item.value
              }, _toDisplayString(_ctx.getBenefitPeriodLabel(item)), 9 /* TEXT, PROPS */, _hoisted_5))
            }), 128 /* KEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */)), [
            [_vModelSelect, _ctx.selectedBenefitPeriod]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("select", {
            key: 1,
            class: "form-select w-35 me-2",
            name: "benefit-periods",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedBenefitPeriod) = $event))
          }, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefitPeriods, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                value: item,
                key: item.value
              }, _toDisplayString(_ctx.getBenefitPeriodLabel(item)), 9 /* TEXT, PROPS */, _hoisted_7))
            }), 128 /* KEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */)), [
            [_vModelSelect, _ctx.selectedBenefitPeriod]
          ]),
      (_ctx.application === _ctx.ApplicationEnum.AxxessHospiceFE)
        ? _withDirectives((_openBlock(), _createElementBlock("select", {
            key: 2,
            class: "form-select w-15 me-2",
            name: "discipline",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDiscipline) = $event))
          }, [
            _hoisted_8,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hosDisciplines, ([key, item]) => {
              return (_openBlock(), _createElementBlock("option", {
                value: item.value,
                key: key
              }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_9))
            }), 128 /* KEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */)), [
            [_vModelSelect, _ctx.selectedDiscipline]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("select", {
            key: 3,
            class: "form-select w-15 me-2",
            name: "discipline",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedDiscipline) = $event))
          }, [
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.palDisciplines, ([key, item]) => {
              return (_openBlock(), _createElementBlock("option", {
                value: item.value,
                key: key
              }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_11))
            }), 128 /* KEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */)), [
            [_vModelSelect, _ctx.selectedDiscipline]
          ]),
      _withDirectives(_createElementVNode("select", {
        class: "form-select w-15 me-2",
        name: "discipline",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedStatus) = $event))
      }, [
        _hoisted_12,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduleStatus, (item) => {
          return (_openBlock(), _createElementBlock("option", {
            value: item.value,
            key: item.value
          }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_13))
        }), 128 /* KEYED_FRAGMENT */))
      ], 512 /* NEED_PATCH */), [
        [_vModelSelect, _ctx.selectedStatus]
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("main", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("table", _hoisted_17, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_18, [
                _createElementVNode("th", null, [
                  _createVNode(_component_SortableTh, {
                    "sort-by": _ctx.sortBy,
                    onSortByUpdated: _ctx.sortByUpdated,
                    "sort-order": _ctx.sortOrder,
                    onSortOrderUpdated: _ctx.sortOrderUpdated,
                    class: "justify-content-start",
                    "sort-string": "TaskName"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_19
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                ]),
                _createElementVNode("th", null, [
                  _createVNode(_component_SortableTh, {
                    "sort-by": _ctx.sortBy,
                    onSortByUpdated: _ctx.sortByUpdated,
                    "sort-order": _ctx.sortOrder,
                    onSortOrderUpdated: _ctx.sortOrderUpdated,
                    class: "justify-content-start",
                    "sort-string": "Status"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                ]),
                _createElementVNode("th", null, [
                  _createVNode(_component_SortableTh, {
                    "sort-by": _ctx.sortBy,
                    onSortByUpdated: _ctx.sortByUpdated,
                    "sort-order": _ctx.sortOrder,
                    onSortOrderUpdated: _ctx.sortOrderUpdated,
                    class: "justify-content-start",
                    "sort-string": "StartDate"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                ]),
                _createElementVNode("th", null, [
                  _createVNode(_component_SortableTh, {
                    "sort-by": _ctx.sortBy,
                    onSortByUpdated: _ctx.sortByUpdated,
                    "sort-order": _ctx.sortOrder,
                    onSortOrderUpdated: _ctx.sortOrderUpdated,
                    class: "justify-content-start",
                    "sort-string": "EndDate"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                ]),
                _createElementVNode("th", null, [
                  _createVNode(_component_SortableTh, {
                    "sort-by": _ctx.sortBy,
                    onSortByUpdated: _ctx.sortByUpdated,
                    "sort-order": _ctx.sortOrder,
                    onSortOrderUpdated: _ctx.sortOrderUpdated,
                    class: "justify-content-start",
                    "sort-string": "UserFirstName"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                ]),
                _hoisted_24,
                _hoisted_25
              ])
            ]),
            _createElementVNode("tbody", null, [
              (!_ctx.isLoading && !_ctx.isError && !_ctx.hasData)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                    _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_29, 8 /* PROPS */, _hoisted_27)
                  ]))
                : _createCommentVNode("v-if", true),
              (!_ctx.isLoading && _ctx.isError)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                    _createElementVNode("td", { colspan: _ctx.columns }, [
                      _createVNode(_component_ErrorMessageHandler, {
                        title: "Unassigned visit list",
                        onTryAgain: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getPatientTasks()))
                      })
                    ], 8 /* PROPS */, _hoisted_31)
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.isLoading)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.loadingCount, (i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "table-loading",
                      key: i
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                        return (_openBlock(), _createElementBlock("td", { key: i }, _hoisted_33))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ]),
            (!_ctx.isLoading && !_ctx.isError && _ctx.hasData)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.allTasks, (task) => {
                  return (_openBlock(), _createElementBlock("tbody", {
                    key: task.Id
                  }, [
                    _createVNode(_component_HosPalTaskRow, {
                      task: task,
                      columns: _ctx.columns,
                      getPatientTasks: _ctx.getPatientTasks
                    }, null, 8 /* PROPS */, ["task", "columns", "getPatientTasks"])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ])
  ]))
}